<!-- 视图下拉选择列表 -->
<template>
<el-popover placement="bottom" width="250" trigger="click"  v-model="visible">
    <div v-if="views">
        <div v-for="view in views" :key="view.id" class="view-item" @click="selectView(view)">
            <span>{{view.name}}</span>
            <i class="el-icon-delete" style="color: red;" @click="(e) => deleteView(e, view)" ></i>
        </div>
    </div>
    <el-link :underline="false" style="font-weight:bold;" slot="reference">
        <div class="wrap" >
            <span class="txt" >{{viewName? viewName : title}}</span>      
        </div>                
    </el-link>
</el-popover>
</template>

<script>

export default {
    name: "ViewsPop",
    data(){
        return {
            views: null,
            viewName: null,
            visible: false,
            view: null
        }
    },
    mounted() {
        this.getViews();
    },
    props: {
        title: String,
        type: String,
    },
    methods: {
        async getViews(){
            try{
                let result = await this.$axios.get(this.$kit.api.user.setting.view.loadViewByType+"?type="+this.type);
                if(result.status){
                    let views = result.data;
                    if(views && views.length>0){
                        views.forEach(view => {
                            if(view.columns) view.columns = JSON.parse(view.columns);
                            if(view.queries) view.queries = JSON.parse(view.queries);
                        });
                        this.views = views;
                        this.view = this.views[0];
                        this.viewName = this.view.name;
                    }
                }
            }catch(err){
                console.log(err);
            }

            this.$emit("load", this.view);
        },
        selectView(view){
            this.viewName = view.name;
            this.visible = false;
            this.view = view;
            this.$emit("change", view);
        },
        async deleteView(e, view){
            e.stopPropagation();
            
            try{
                let result = await this.$axios.get(this.$kit.api.user.setting.view.deleteView+"?id="+view.id);
                if(result.status){
                    let index = this.views.findIndex(s => s.id = view.id);
                    if(index>-1){
                        this.views.splice(index, 1);
                        if(view.id ==  this.view.id){
                            if(this.views[index]){
                                this.view = this.views[index];
                                this.viewName = view.name;
                                this.$emit("change",this.view);
                            }
                        }
                    }
                }
                this.$message(result.msg);
            }catch(err){
                console.log(err);
                this.$message(err);
            }

        }
    }
}

</script>

<style lang="scss" scoped>

.view-item{
    padding: 6px 10px;
    cursor: pointer;
    display:flex;
    justify-content: space-between;
}

.view-item i{
    opacity: 0;
}

.view-item.active, .view-item:hover{
    color: #409eff;
    background: rgba(64, 158, 255, .1);
}

.view-item:hover i{
    opacity: 1;
}

</style>